export type GdprRequest = {
  id: number;
  adminId: number;
  candidate: any;
  candidateId: number;
  kind: GdprRequestKind;
  message: string;
  completedAt: string;
  createdAt: string;
};

export enum GdprRequestKind {
  Removal = 'removal',
  Correction = 'change',
}

export type OfferConfiguration = {
  id: number;
  emailConfirmation: boolean;
};

export type GdprConfiguration = {
  id: number;
  adminIds: number[];
  admins: any[];
  expirationDays: number;
  enabled: boolean;
  emailConfirmationFooterHtml: string;
  defaultEmailConfirmationFooterHtml: string;
  offers: OfferConfiguration[];
  companyId: number;
  translations: GdprTranslationItem[];
  consentPrivacyLink: string;
  autoConsent: {
    enabled: boolean;
    emailBodyHtml: string | null;
    emailSubject: string | null;
    extendPeriodForDays: number | null;
    sendToCandidatesWithoutEmailActivityInDays: boolean | null;
    sendToQualified: boolean | null;
  };
  autoDelete: {
    enabled: boolean | null;
    deleteActiveInJobsAndTalentPools: boolean | null;
    deleteCandidatesWithoutConsentRequests: boolean | null;
    deleteRequestedCandidatesInDays: number | null;
    deleteWithoutEmailActivityInDays: number | null;
  };
};

export type GdprSaveBody = {
  adminsIds?: number[];
  translations?: GdprSaveBodyTranslations[];
  expirationDays?: number;
  enabled?: boolean;
};

export type GdprSaveBodyTranslations = {
  emailConfirmationFooterHtml?: string;
  langCode?: string;
};

export type GdprTranslationItem = {
  defaultEmailConfirmationFooterHtml: string;
  emailConfirmationFooterHtml: string;
  language: GdprLanguageItem;
  primary: boolean;
};

type GdprLanguageItem = {
  code: string;
  name: string;
  nativeName: string;
  translationFieldsCount?: number;
};
export type GdprAutoDeleteCounter = {
  candidatesCount: number;
};
export type GdprAutoConsentCounter = GdprAutoDeleteCounter;
